import { gql } from 'graphql-tag'

export const SET_PERSON_EMAIL = gql`
  mutation SetUserEmail($partyInput: PartyInput!) {
    setUserEmail(partyInput: $partyInput)
  }
`
